import { render, staticRenderFns } from "./UsersDetailTab.vue?vue&type=template&id=5d1715a2&scoped=true&"
import script from "./UsersDetailTab.vue?vue&type=script&lang=js&"
export * from "./UsersDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetailTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UsersDetailTab.vue?vue&type=style&index=1&id=5d1715a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1715a2",
  null
  
)

export default component.exports